import { z } from 'my-zod'
import { customersModel } from '../../customer-operations/customer/customers-model'

export const selectSubscriptionSetupView = z.object({
  customer: customersModel.pick({
    email: true,
    firstName: true,
    lastName: true,
    city: true,
    country: true,
    addressLine1: true,
    addressLine2: true,
    postalCode: true,
    state: true,
    primaryPhone: true,
    referringPartnerId: true,
    marketingOptIn: true
  }),
  promotionalCode: z.ostring(),
  // In theory, 'base' | 'plus' | 'ultimate' | 'beta' | 'test'
  planName: z.string(),
  market: z.string().nullable(),
  paymentMethod: z.string(),
  isFullTermPayment: z.oboolean()
})
export type selectSubscriptionSetupView = z.infer<typeof selectSubscriptionSetupView>
